import { render, staticRenderFns } from "./StudentParent.vue?vue&type=template&id=18492327&scoped=true&"
import script from "./StudentParent.vue?vue&type=script&lang=js&"
export * from "./StudentParent.vue?vue&type=script&lang=js&"
import style0 from "./StudentParent.vue?vue&type=style&index=0&id=18492327&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18492327",
  null
  
)

export default component.exports